import PropTypes from 'prop-types';
import React from 'react';
import LoadingPlaceholderFullPage from 'components/shared/LoadingPlaceholderFullPage';
import usePollAnswersForActivity from 'api-new/stim-based/usePollAnswersForActivity';
import { PollActivityVotesIndicator as RCPollActivityVotesIndicator } from '@visionslive/reporting-components';

const PollActivityVotesIndicator = ({ activityId, crossSessionId }) => {
    const { data: pollAnswers, isLoading: isLoadingPollAnswers } = usePollAnswersForActivity({ activityId, crossSessionId });

    if (isLoadingPollAnswers) {
        return <LoadingPlaceholderFullPage />;
    }

    return (
        <RCPollActivityVotesIndicator responses={pollAnswers} />
    );
};

PollActivityVotesIndicator.propTypes = {
    activityId: PropTypes.string,
    crossSessionId: PropTypes.string,
    focusGroupId: PropTypes.string
};

export default PollActivityVotesIndicator;
